module.exports = __webpack_public_path__ + "img/img13.d96c2af1.png";